import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import resources from './locales';

const languages = [

  {
    code: 'en',
    name: 'English (US)',
  },
  {
    code: 'fr',
    name: 'French (Français)',
  },
];

i18n.use(initReactI18next).init({
  resources,
  lng: 'fr',
  fallbackLng: 'fr',
});

export { languages };

export default i18n;
